import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { GridOverlay } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';


const CustomNoRowsOverlay = (message) => {
  return (
    <GridOverlay>
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <p style={{ color: '#424E54', fontSize: 14, fontWeight: 600 }}>{message}</p>
      </div>
    </GridOverlay>
  );
};

export default function DlmDataGrid(props) {
    const { t } = useTranslation();
    const {rows, columns, onRowSelectionChange,searchTerm} = props;
    const hasData = rows?.length > 0 ;

    const flexibleColumns = columns?.map(col => ({
        ...col,
        flex: col.flex || 1,
    })) || [];

    return (
        <Box sx={{ height: 400, width: '100%' }}>
            <DataGrid
                rows={rows}
                columns={flexibleColumns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 100,
                        },
                    },
                }}
                pageSizeOptions={[25,50,100]}
                checkboxSelection={hasData}
                hideFooter={!hasData}
                disableRowSelectionOnClick
                disableColumnMenu
                sortingOrder={['asc', 'desc', null]}
                onRowSelectionModelChange={onRowSelectionChange}
                slots={{
                    noRowsOverlay: () => CustomNoRowsOverlay(searchTerm > 0 ? t('translation:pages.dlm.new_job.no_data_message_with_search') : t('translation:pages.dlm.new_job.no_data_message')),
                }}
                sx={{
                    '& .MuiDataGrid-columnHeadersInner': {
                        width: '100% !important',
                    },
                }}
            />
        </Box>
    );
}
